import { render, staticRenderFns } from "./EventPreset.vue?vue&type=template&id=3a248ace"
import script from "./EventPreset.vue?vue&type=script&lang=js"
export * from "./EventPreset.vue?vue&type=script&lang=js"
import style0 from "./EventPreset.vue?vue&type=style&index=0&id=3a248ace&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports